module.exports = __webpack_public_path__ + "img/pembayaran.bbbc359a.jpg";